module.exports = __webpack_public_path__ + "static/media/gif_SE_step_6.b93ccf2b.gif";